export const displayMore = {
    init: (elementHtmlTag: HTMLElement) => {
        const moreLabel: string | undefined = elementHtmlTag.dataset.labelMore;
        const lessLabel: string | undefined = elementHtmlTag.dataset.labelLess;
        const fullText: string = elementHtmlTag.innerHTML;
        if (fullText) {
            const readMore = new DisplayMore(
                elementHtmlTag,
                moreLabel,
                lessLabel,
                fullText
            );
            readMore.truncate();
        }
    },
};
class DisplayMore {
    container: HTMLElement;
    currentState: string;
    moreLabel: string | undefined;
    lessLabel: string | undefined;
    fullText: string;
    constructor(
        container: HTMLElement,
        moreLabel: string | undefined,
        lessLabel: string | undefined,
        fullText: string
    ) {
        this.container = container;
        this.currentState = 'full';
        this.moreLabel = moreLabel;
        this.lessLabel = lessLabel;
        this.fullText = fullText;
    }
    truncate() {
        const list = Array.from(this.container.querySelectorAll('li'));
        if (list.length > 3) {
            const newList = list.slice(0, 3);
            let newText = '';
            newList.forEach((value: HTMLLIElement) => {
                newText += '<li>' + value.innerHTML + '</li>';
            });
            newText += `<li class="align-right "><button class="btn-no-look" data-action="toggleText">${this.moreLabel}</button></li>`;
            this.container.innerHTML = newText;
            this.currentState = 'truncated';
        }
        document.addEventListener('mousedown', this.addListener.bind(this));
    }
    toggleText() {
        if (this.currentState === 'truncated') {
            this.container.innerHTML =
                this.fullText +
                `<li class="align-right "><button class="btn-no-look" data-action="toggleText">${this.lessLabel}</button></li`;
            this.currentState = 'full';
        } else {
            this.truncate();
        }
    }
    addListener(event: Event) {
        const toggleButton = this.container.querySelector(
            '[data-action="toggleText"]'
        );
        if (toggleButton === event.target) {
            event.preventDefault();
            this.toggleText();
        }
    }
}
